import React from 'react';
import { find, map } from 'lodash';
import { useSelector } from 'react-redux';
import { MenuItem } from '@mui/material';
import { useForm } from 'react-final-form';

import SelectField from 'common/forms/SelectField';

const FacilityFilterField = () => {
  const form = useForm();
  const userAuth = useSelector(({ auth }) => auth);

  const fulfillingPharmacies = userAuth?.fulfillingPharmacies;
  const currentTenantId = userAuth?.currentTenantId;
  const facilities = useSelector(({ pharmacy }) => pharmacy[currentTenantId] || []);

  const displayValue =
    fulfillingPharmacies?.length === 1 ? fulfillingPharmacies[0]?.fulfillingPharmacyId : undefined;

  const onChange = (value) => {
    form.change('fulfillingPharmacyIds', value ? [value] : '');
  };

  return (
    <SelectField
      label='Facility'
      name='fulfillingPharmacyIds'
      id='filter-facility-dropdown'
      disabled={!!displayValue}
      staticDisplayValue={displayValue}
      onChange={(e) => onChange(e.target.value)}
    >
      <MenuItem value=''>All</MenuItem>
      {map(fulfillingPharmacies, ({ fulfillingPharmacyId, fulfillingPharmacyName }) => {
        const facilityState = find(
          facilities,
          (facility) => facility.fulfillingPharmacyId === fulfillingPharmacyId
        )?.state;

        return (
          <MenuItem key={fulfillingPharmacyId} value={fulfillingPharmacyId}>
            {fulfillingPharmacyName} - {facilityState}
          </MenuItem>
        );
      })}
    </SelectField>
  );
};

export default FacilityFilterField;
